// extracted by mini-css-extract-plugin
module.exports = {"button-wrapper":"EditSubscription_button-wrapper__1HDHG"};